import { Scheduling } from "@/types";
import { httpRequest } from "../../lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface SynchronizeAllScheduleRequest {
  message: string;
  data: Scheduling;
}

async function createSynchronizeAllSchedulings() {
  const response = await httpRequest.post<SynchronizeAllScheduleRequest>(
    "/schedulings/sync-all"
  );
  return response.data;
}

export function useCreateSynchronizeAllSchedulingsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSynchronizeAllSchedulings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
